'use client';

import { c as _c } from "react/compiler-runtime";
import { StaticBanner } from './StaticBanner';
interface BannerProps {
  policyBannerTypeList?: string[];
  idx: string;
}
export const Banner = t0 => {
  const $ = _c(1);
  const {
    policyBannerTypeList,
    idx
  } = t0;
  if (policyBannerTypeList?.length) {
    return null;
  }
  switch (idx) {
    case "3150f149-2eb2-43d7-8ec4-165ac135a087":
      {
        let t1;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
          t1 = <StaticBanner bannerList={["K \uD328\uC2A4"]} className="mb-28 px-24 mobile-tablet:px-16" />;
          $[0] = t1;
        } else {
          t1 = $[0];
        }
        return t1;
      }
    default:
      {
        return null;
      }
  }
};